import Banner from './components/Banner';
import Features from '@/components/Features';
import { FEATURES_LIST, SKILL_LIST } from './index.js';
import Skill from '@/components/Skill';
import Cases from './components/Cases';
import Appointment2 from '@/components/Appointment2/index.vue';
import Function from './components/Function';
export default {
  components: {
    Banner,
    Features,
    Function,
    Skill,
    Cases,
    Appointment2
  },
  data() {
    return {
      featuresList: FEATURES_LIST,
      skillList: SKILL_LIST,
      productId: this.$productId.PC_KE_HU_DUAN.PC_JIN_RONG_ZHONG_DUAN
    };
  }
};